/**
 * @generated SignedSource<<ea402144a56976b15557a392129f8503>>
 * @relayHash 363793ae7e2f5e7cf4a4ceffde926c80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0361c8999900471b4309a5ed07f88caa69a18cff2dcf0e21e24b6442cc5bb367

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
};
export type ProjectPanelQuery$data = {
  readonly townsquare: {
    readonly project: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectPanelHeader">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProjectPanelHeader"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "concreteType": "TownsquareIconURIs",
                "kind": "LinkedField",
                "name": "iconUrl",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareThemeURIs",
                    "kind": "LinkedField",
                    "name": "roundedSquare",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "dark"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "light"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0361c8999900471b4309a5ed07f88caa69a18cff2dcf0e21e24b6442cc5bb367",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b55c01175adec5a33fe1ad0412583a08";

export default node;
